type Props = {
  docked: boolean;
  width: number;
  children: React.ReactNode;
};

/**
 * Shared shell for the right-side panels: a detached card docked next to the
 * board on desktop, a slide-in overlay on smaller screens.
 */
const SidePanel = ({ docked, width, children }: Props) => {
  if (docked) {
    return (
      <aside className="flex-none flex flex-col min-h-0 rounded mt-0.5 mr-4 mb-4 bg-brand-white" style={{ width }}>
        {children}
      </aside>
    );
  }

  return (
    <aside
      className="kds-panel-in absolute top-0 right-0 bottom-0 z-50 flex flex-col min-h-0 shadow-[0_0_30px_rgba(0,0,0,0.15)] bg-brand-white"
      style={{ width, maxWidth: '88%' }}
    >
      {children}
    </aside>
  );
};

export default SidePanel;
